import React, { FC, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { defineMessages, IntlContext } from "react-intl";
import { TabBar, TabItem } from "@natera/material/lib/tab";
import classNames from "classnames";

import { PostbillBillingCenter } from "@app/pages";
import { routes } from "@app/routing";
import { BillingCenterHistory } from "@app/postBill/components/billingCenterHistory";
import BillingCenterHelp from "@app/postBill/components/billingCenterHelp";
import { usePostBillHeapEvent } from "@app/postBill/hooks";
import { BillingMenuContext } from "@app/components/navigation/billingMenuContext";

import "./billingCenterTab.scss";
import { HEAP_EVENTS } from "@app/provider/types";

const messages = defineMessages({
  billingTabMyBills: {
    id: "billingTabMyBills",
    defaultMessage: "My bills",
  },
  billingTabHistory: {
    id: "billingTabHistory",
    defaultMessage: "History",
  },
  billingTabFAQ: {
    id: "billingTabHelp",
    defaultMessage: "Help",
  },
});

enum BillingTabs {
  MyBillsTab = 0,
  HistoryTab = 1,
  HelpTab = 2,
}

const BillingCenterTab: FC = () => {
  const intl = useContext(IntlContext);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(BillingTabs.MyBillsTab);
  const { trackPostBillHeapEvent } = usePostBillHeapEvent();
  const { isMenuOpen } = useContext(BillingMenuContext);

  useEffect(() => {
    if (
      location.state?.from === routes.billingHistoryPayments ||
      location.state?.from === routes.billingCenterPaymentPlanHistory
    ) {
      setActiveTab(BillingTabs.HistoryTab);
      window.history.replaceState({}, "");
    }
  }, [location.state]);

  return (
    <div
      className={classNames("billing-center-tab", {
        "billing-center-tab--menu-open": isMenuOpen,
      })}
    >
      <TabBar>
        <TabItem
          active={activeTab === BillingTabs.MyBillsTab}
          onClick={() => {
            setActiveTab(BillingTabs.MyBillsTab);
            trackPostBillHeapEvent({
              eventKey: HEAP_EVENTS.upp_click_mybills_tab,
            });
          }}
        >
          {intl.formatMessage(messages.billingTabMyBills)}
        </TabItem>
        <TabItem
          active={activeTab === BillingTabs.HistoryTab}
          onClick={() => {
            setActiveTab(BillingTabs.HistoryTab);
            trackPostBillHeapEvent({
              eventKey: HEAP_EVENTS.upp_click_billing_history_tab,
            });
          }}
        >
          {intl.formatMessage(messages.billingTabHistory)}
        </TabItem>
        <TabItem
          active={activeTab === BillingTabs.HelpTab}
          onClick={() => {
            setActiveTab(BillingTabs.HelpTab);
            trackPostBillHeapEvent({
              eventKey: HEAP_EVENTS.upp_click_billing_help_tab,
            });
          }}
        >
          {intl.formatMessage(messages.billingTabFAQ)}
        </TabItem>
      </TabBar>

      <div className="billing-center-tab__content">
        {activeTab === BillingTabs.MyBillsTab && <PostbillBillingCenter />}
        {activeTab === BillingTabs.HistoryTab && <BillingCenterHistory />}
        {activeTab === BillingTabs.HelpTab && <BillingCenterHelp />}
      </div>
    </div>
  );
};

export default BillingCenterTab;
